export default __webpack_public_path__ + "f9fd6781ae2d587f2fbd5543f6c867f7.png";